import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=add4bd6a&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&lang=ts"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=add4bd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add4bd6a",
  null
  
)

export default component.exports